import { useState } from 'react';
import Layout from '../../components/ui/Layout';
import Card from '../../components/ui/Card';
import Button from '../../components/ui/Button';
import { toast } from '../../components/ui/Toast';
import { useTranslation } from '../../i18n/LanguageContext';
import { IconBell, IconCheck } from '@tabler/icons-react';

const NOTIFICATION_SETTINGS = [
  { key: 'checkFailed',           labelKey: 'set.notif_check_failed',    descriptionKey: 'set.notif_check_failed_desc'    },
  { key: 'machineBlocked',        labelKey: 'set.notif_machine_blocked', descriptionKey: 'set.notif_machine_blocked_desc' },
  { key: 'defectReported',        labelKey: 'set.notif_defect',          descriptionKey: 'set.notif_defect_desc'          },
  { key: 'nearMissReported',      labelKey: 'set.notif_near_miss',       descriptionKey: 'set.notif_near_miss_desc'       },
  { key: 'qualificationExpiring', labelKey: 'set.notif_qual_expiring',   descriptionKey: 'set.notif_qual_expiring_desc'   },
  { key: 'qualificationExpired',  labelKey: 'set.notif_qual_expired',    descriptionKey: 'set.notif_qual_expired_desc'    },
  { key: 'serviceDue',            labelKey: 'set.notif_service_due',     descriptionKey: 'set.notif_service_due_desc'     },
  { key: 'fuelLow',               labelKey: 'set.notif_fuel_low',        descriptionKey: 'set.notif_fuel_low_desc'        },
  { key: 'emergency',             labelKey: 'set.notif_emergency',       descriptionKey: 'set.notif_emergency_desc'       },
  { key: 'announcement',          labelKey: 'set.notif_announcement',    descriptionKey: 'set.notif_announcement_desc'    },
];

export default function Notifications() {
  const { t } = useTranslation();
  const [settings, setSettings] = useState({
    checkFailed: true,
    machineBlocked: true,
    defectReported: true,
    nearMissReported: true,
    qualificationExpiring: true,
    qualificationExpired: true,
    serviceDue: true,
    fuelLow: true,
    emergency: true,
    announcement: true,
  });

  const toggle = (key) => {
    if (key === 'emergency') return;
    setSettings(prev => ({ ...prev, [key]: !prev[key] }));
  };

  const handleSave = () => {
    toast.success(t('set.notif_saved'));
  };

  return (
    <Layout>
      <div style={{ padding: 'var(--main-padding)', maxWidth: 600, margin: '0 auto' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 24 }}>
          <IconBell size={20} color="var(--color-text-secondary)" stroke={1.5} />
          <h1 style={{ fontSize: 22, fontWeight: 400 }}>{t('set.notif_title')}</h1>
        </div>
        <Card style={{ marginBottom: 20 }}>
          <div style={{ fontSize: 13, color: 'var(--color-text-tertiary)', marginBottom: 16, lineHeight: 1.6 }}>
            {t('set.notif_desc')}
          </div>
          {NOTIFICATION_SETTINGS.map((setting, i) => (
            <div
              key={setting.key}
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 0', borderBottom: i < NOTIFICATION_SETTINGS.length - 1 ? '0.5px solid var(--color-border-light)' : 'none' }}
            >
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 13, color: setting.key === 'emergency' ? 'var(--color-text-tertiary)' : 'var(--color-text-primary)' }}>{t(setting.labelKey)}</div>
                <div style={{ fontSize: 11, color: 'var(--color-text-tertiary)', marginTop: 2 }}>{t(setting.descriptionKey)}</div>
              </div>
              <div
                onClick={() => toggle(setting.key)}
                style={{
                  width: 42,
                  height: 24,
                  borderRadius: 12,
                  background: settings[setting.key] ? 'var(--color-brand)' : 'var(--color-bg-tertiary)',
                  position: 'relative',
                  cursor: setting.key === 'emergency' ? 'not-allowed' : 'pointer',
                  transition: 'background 0.2s',
                  flexShrink: 0,
                  opacity: setting.key === 'emergency' ? 0.6 : 1,
                }}
              >
                <div style={{
                  width: 18,
                  height: 18,
                  borderRadius: '50%',
                  background: '#fff',
                  position: 'absolute',
                  top: 3,
                  left: settings[setting.key] ? 21 : 3,
                  transition: 'left 0.2s',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.15)',
                }} />
              </div>
            </div>
          ))}
        </Card>
        <Button variant="primary" icon={<IconCheck size={14} stroke={1.5} />} onClick={handleSave}>
          {t('set.save_preferences')}
        </Button>
      </div>
    </Layout>
  );
}